import { EOfficeType } from '../../../json_query';

export const MULTI_ADS_OFFICE_TYPES = [
  EOfficeType.Office,
  EOfficeType.FreeAppointmentObject,
  EOfficeType.TradeArea,
  EOfficeType.Warehouse,
  EOfficeType.Manufacture,
];
